var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFranceFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twemoji:flag-france",
    clipPath: "url(#clip0_640_3612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.7805 16.1219C20.7805 16.7343 20.5372 17.3216 20.1042 17.7546C19.6712 18.1876 19.0839 18.4309 18.4715 18.4309H13.8536V3.42273H18.4715C19.0839 3.42273 19.6712 3.66599 20.1042 4.099C20.5372 4.53201 20.7805 5.1193 20.7805 5.73167V16.1219Z",
    fill: "#ED2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.30894 3.42273C1.69657 3.42273 1.10928 3.66599 0.676274 4.099C0.243263 4.53201 0 5.1193 0 5.73167L0 16.1219C0 16.7343 0.243263 17.3216 0.676274 17.7546C1.10928 18.1876 1.69657 18.4309 2.30894 18.4309H6.92683V3.42273H2.30894Z",
    fill: "#002495"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.92682 3.42273H13.8536V18.4309H6.92682V3.42273Z",
    fill: "#EEEEEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_640_3612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.7805,
    height: 20.7805,
    fill: "white",
    transform: "translate(0 0.53656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFranceFlag);
export default __webpack_public_path__ + "static/media/France_Flag.05d8a74c5f36e775c43ae35027b1d28e.svg";
export { ForwardRef as ReactComponent };